import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import DotsHorizontalIcon from "@untitled-ui/icons-react/build/esm/DotsHorizontal";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { usePopover } from "~/hooks/use-popover";
import { useDeleteProcess } from "~/queries/useDeleteProcess";
import { Process } from "~/types/__generated/gql/graphql";
import type { FC } from "react";
import { ProcessModal } from "../process-card/process-form";
import { Box, TableCell, useTheme } from "@mui/material";
import { useAppRouter } from "~/hooks/use-app-router";
import { Add } from "@mui/icons-material";
interface ProcessHeaderProps {
  key: string;
  process: Process;
  isLast: boolean;
}
export const ProcessTableHeader: FC<ProcessHeaderProps> = ({
  key,
  process,
  isLast
}) => {
  const theme = useTheme();
  const borderColor = theme.palette.divider;
  const deleteProcess = useDeleteProcess();
  const popover = usePopover<HTMLButtonElement>();
  const [updateId, setUpdateId] = useState<string | null>(null);
  const {
    goToCreateFileQuery
  } = useAppRouter();
  const onDelete = async (columnId: string): Promise<void> => {
    try {
      await deleteProcess.mutateAsync({
        id: columnId
      });
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    }
  };
  const handleDelete = useCallback((): void => {
    popover.handleClose();
    void onDelete(process._id);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popover, onDelete]);
  const handleAddInit = (processId: string) => {
    void goToCreateFileQuery(processId);
  };
  return <>
			{!!updateId && <ProcessModal processId={updateId} onClose={() => setUpdateId(null)} />}
			<TableCell key={key} variant="head" sx={isLast ? {} : {
      borderRight: `1px solid ${borderColor}`
    }} data-sentry-element="TableCell" data-sentry-source-file="process-table-header.tsx">
				<Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} data-sentry-element="Stack" data-sentry-source-file="process-table-header.tsx">
					<Box data-sentry-element="Box" data-sentry-source-file="process-table-header.tsx">{process.name}</Box>
					<Box data-sentry-element="Box" data-sentry-source-file="process-table-header.tsx">
						<IconButton color="primary" onClick={() => {
            handleAddInit(process._id);
          }} data-sentry-element="IconButton" data-sentry-source-file="process-table-header.tsx">
							<SvgIcon data-sentry-element="SvgIcon" data-sentry-source-file="process-table-header.tsx">
								<Add data-sentry-element="Add" data-sentry-source-file="process-table-header.tsx" />
							</SvgIcon>
						</IconButton>
						<IconButton edge="end" onClick={popover.handleOpen} ref={popover.anchorRef} data-sentry-element="IconButton" data-sentry-source-file="process-table-header.tsx">
							<SvgIcon data-sentry-element="SvgIcon" data-sentry-source-file="process-table-header.tsx">
								<DotsHorizontalIcon data-sentry-element="DotsHorizontalIcon" data-sentry-source-file="process-table-header.tsx" />
							</SvgIcon>
						</IconButton>
						<Menu anchorEl={popover.anchorRef.current} transformOrigin={{
            horizontal: "right",
            vertical: "top"
          }} anchorOrigin={{
            horizontal: "right",
            vertical: "bottom"
          }} keepMounted onClose={popover.handleClose} open={popover.open} data-sentry-element="Menu" data-sentry-source-file="process-table-header.tsx">
							<MenuItem onClick={() => {
              popover.handleClose();
              setUpdateId(process._id);
            }} data-sentry-element="MenuItem" data-sentry-source-file="process-table-header.tsx">
								Update
							</MenuItem>
							<MenuItem onClick={handleDelete} data-sentry-element="MenuItem" data-sentry-source-file="process-table-header.tsx">Delete</MenuItem>
						</Menu>
					</Box>
				</Stack>
			</TableCell>
		</>;
};